import Logo from "@assets/header/header-logo.svg";
import LogoDark from "@assets/header/header-logo-dark.svg";
import mLogoDark from "@assets/header/header-logo-dark-m.svg";
import mLogo from "@assets/header/header-logo-m.svg";
import Link from "@components/Link";
import Nav from "@components/Navigater";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import clsx from "clsx";

interface HeaderLogoProps {
  theme: ThemeEnum;
  isHeaderSticky: boolean;
  isSmallScreen: boolean;
  navList: Array<{ name: string; path: string }>;
}

export default function HeaderLogo({
  theme,
  isHeaderSticky,
  isSmallScreen,
  navList,
}: HeaderLogoProps) {
  return (
    <>
      <Link to="/">
        {/* PC端Logo */}
        {theme === ThemeEnum.dark ? (
          <img
            src={LogoDark}
            alt="logo"
            className={clsx(
              "hidden transition-opacity duration-500 ease-in-out lg:block",
              isHeaderSticky || isSmallScreen ? "!hidden" : "!lg:block",
            )}
          />
        ) : (
          <img
            src={Logo}
            alt="logo"
            className={clsx(
              "hidden transition-opacity duration-500 ease-in-out lg:block",
              isHeaderSticky || isSmallScreen ? "!hidden" : "!lg:block",
            )}
          />
        )}

        {/* 移动端Logo */}
        {theme === ThemeEnum.dark ? (
          <img src={mLogoDark} alt="logo" className="block lg:hidden" />
        ) : (
          <img src={mLogo} alt="logo" className="block lg:hidden" />
        )}
      </Link>

      {isHeaderSticky && !isSmallScreen && (
        <div>
          <Nav navList={navList} />
        </div>
      )}
    </>
  );
}
